import classNames from "classnames";
import buttonStyles from "./Button.module.scss";
export const Button = ({ children, onClick, className, disabled, bgColor }) => {
  const buttonClass = classNames(className, "text-md", buttonStyles.button, {
    [buttonStyles["black"]]: bgColor === "black",
  });
  return (
    <button className={buttonClass} onClick={onClick} disabled={disabled}>
      {children}
    </button>
  );
};
